/**
 * Apply Classes
 *
 * Merge an unknown object, string or array coming
 * from a component's `classes` prop.
 */

function format(className: any): object {
  if (!className) {
    return {};
  }
  if (Array.isArray(className)) {
    return applyClasses(...className);
  }
  return typeof className === 'object' ? className : { [className]: true };
}

function applyClasses(...classes: any[]): object {
  return Object.assign({}, ...classes.map(format));
}

export default applyClasses;
